import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  MdCallEnd,
  MdOutlineScreenShare,
  MdOutlineStopScreenShare,
  MdShare,
  MdContentCopy,
  MdCheck,
} from "react-icons/md";
import {
  FaMicrophone,
  FaMicrophoneSlash,
  FaVideo,
  FaVideoSlash,
  FaUsers,
} from "react-icons/fa6";
import { LuSlash } from "react-icons/lu";
import { BsChatLeftDotsFill } from "react-icons/bs";
import { HiDotsVertical } from "react-icons/hi";
import { AuthContext } from "../../contexts/AuthContext";
import { leaveMeeting } from "../../services/mediasoup-client";
import {
  toggleVideo,
  toggleAudio,
} from "../../services/web-RTC";
import { useMediasoupClient } from "../../hooks/useMediasoupClient";
import { useMeeting } from "../../hooks/useMeeting";
import { socket } from "../../services/socket";
import {
  groupConsumersByUser,
  consumeRemoteStreamVideo,
} from "../../services/mediasoup-client";

export default function FooterMeetVideoMobile({
  display,
  setNewMessage,
  toggleRaiseHand,
  raisedHands,
  setDisplay,
  accessCode,
  mediasTools,
  newMessage,
}) {
  const { constraints, isMuted, setIsMuted, setShowCodeOrLink } = mediasTools;
  const location = useNavigate();
  const {
    setLocalStream,
    localStream,
    screenStream,
    setMyPeer,
    myPeer,
    participants,
    setParticipants,
    endMeetingSession,
  } = useMeeting();
  const {
    isScreenSharing,
    setIsScreenSharing,
    setScreenStream,
    setSendTransport,
    setRecvTransport,
    producerAudio,
    setProducerAudio,
    producerVideo,
    setProducerVideo,
    sendTransport,
    recvTransport,
  } = useMediasoupClient();
  const { user } = useContext(AuthContext);
  const [mainlevee, setMainLevee] = useState(false);
  const [displayVideo, setDisplayVideo] = useState(constraints.video);
  const [sheetOpen, setSheetOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const handRef = useRef(null);

  useEffect(() => {
    socket.on("old_participant_produce_video", async (consumers) => {
      for (const consumer of groupConsumersByUser(consumers)) {
        await consumeRemoteStreamVideo(
          consumer,
          recvTransport,
          setParticipants,
          participants
        );
      }
    });
    return () => {
      socket.off("old_participant_produce_video");
    };
  }, [participants, socket]);

  const handleClick = () => {
    if (!mainlevee && handRef.current) {
      const el = handRef.current;
      el.classList.remove("clicked");
      void el.offsetWidth;
      el.classList.add("clicked");
      const removeClass = () => {
        el.classList.remove("clicked");
        el.removeEventListener("animationend", removeClass);
      };
      el.addEventListener("animationend", removeClass);
    }
  };

  const toggleDemanderLaParole = () => {
    toggleRaiseHand();
    handleClick();
    setMainLevee(!mainlevee);
  };

  const doLeaveMeeting = () => {
    if (mainlevee) toggleDemanderLaParole();
    leaveMeeting({
      userId: user.userId,
      location,
      endMeetingSession,
      setSendTransport,
      setRecvTransport,
      setProducerAudio,
      setProducerVideo,
      setIsScreenSharing,
      setScreenStream,
      sendTransport,
      recvTransport,
      producerVideo,
      producerAudio,
      localStream,
      screenStream,
    });
  };

  const options = [
    {
      label: isMuted ? "Activer micro" : "Couper micro",
      icon: isMuted ? <FaMicrophoneSlash /> : <FaMicrophone />,
      action: () =>
        toggleAudio({
          isMuted,
          setIsMuted,
          producerAudio,
          participants,
          setParticipants,
          user,
        }),
    },
    {
      label: displayVideo ? "Couper camera" : "Activer camera",
      icon: displayVideo ? <FaVideo /> : <FaVideoSlash />,
      action: () =>
        toggleVideo(
          {
            producerVideo,
            participants,
            setParticipants,
            displayVideo,
            setDisplayVideo,
            user,
          },
          {
            sendTransport,
            setProducerVideo,
            localStream,
            setMyPeer,
            myPeer,
            setLocalStream,
            isMuted,
          }
        ),
    },
    {
      label: isScreenSharing ? "Arrêter partage" : "Partage d'écran",
      icon: isScreenSharing ? <MdOutlineStopScreenShare /> : <MdOutlineScreenShare />,
      action: () =>
        alert("fonctionnalité en cours de developpement"),
    },
    {
      label: mainlevee ? "Baisser main" : "Lever main",
      icon: (
        <span
          ref={handRef}
          className="hand"
          style={{ fontSize: "18px", bottom: 0 }}
        >
          {raisedHands.find((p) => p.userId === user.userId) ? (
            <>
              <LuSlash
                style={{
                  color: "red",
                  fontSize: "22px",
                  position: "absolute",
                  left: "20%",
                  top: "15%",
                }}
              />
              <span>🖐🏾</span>
            </>
          ) : (
            <span>🖐🏾</span>
          )}
        </span>
      ),
      action: () => toggleDemanderLaParole(),
    },
    {
      label: `Participants (${participants.length})`,
      icon: <FaUsers />,
      action: () => {},
    },
    {
      label: "Chat",
      icon: <BsChatLeftDotsFill />,
      badge: newMessage && !display,
      action: () => {
        setNewMessage(false);
        setDisplay(!display);
        setSheetOpen(false);
      },
    },
    {
      label: copied ? "Copie !" : "Copier code",
      icon: copied ? (
        <MdCheck style={{ color: "#00b074" }} />
      ) : (
        <MdContentCopy />
      ),
      action: () => {
        navigator.clipboard.writeText(accessCode).then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2500);
        });
      },
      keepOpen: true,
    },
    {
      label: "Partager code",
      icon: <MdShare />,
      action: () => {
        setShowCodeOrLink(true);
        setSheetOpen(false);
      },
      keepOpen: true,
    },
  ];

  return (
    <>
      {/* Bottom sheet backdrop */}
      {sheetOpen && (
        <div style={backdropStyle} onClick={() => setSheetOpen(false)} />
      )}

      {/* Bottom sheet */}
      {sheetOpen && (
        <div style={sheetStyle}>
          <div style={handleBarStyle} />
          <div style={optionsGridStyle}>
            {options.filter(o => !o.hidden).map((opt, i) => (
              <button
                key={i}
                style={optionBtnStyle}
                onClick={() => {
                  opt.action();
                  if (!opt.keepOpen) setSheetOpen(false);
                }}
              >
                <div style={optionIconStyle}>
                  {opt.icon}
                  {opt.badge && <div style={badgeDotStyle} />}
                </div>
                <span style={optionLabelStyle}>{opt.label}</span>
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Barre compacte : mic + end call + dots */}
      <div style={barStyle}>
        <span
          style={micBtnStyle}
          onClick={() =>
            toggleAudio({
              isMuted,
              setIsMuted,
              producerAudio,
              participants,
              setParticipants,
              user,
            })
          }
        >
          {isMuted ? (
            <FaMicrophoneSlash style={{ color: "#fff", fontSize: "18px" }} />
          ) : (
            <FaMicrophone style={{ color: "#fff", fontSize: "18px" }} />
          )}
        </span>

        <span style={endCallBtnStyle} onClick={doLeaveMeeting}>
          <MdCallEnd style={{ color: "#fff", fontSize: "22px" }} />
        </span>

        <span style={dotsBtnStyle} onClick={() => setSheetOpen(!sheetOpen)}>
          <HiDotsVertical style={{ color: "#fff", fontSize: "20px" }} />
          {newMessage && !display && <div style={badgeDotBarStyle} />}
        </span>
      </div>
    </>
  );
}

const barStyle = {
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  height: "56px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "20px",
  zIndex: 19,
  backgroundColor: "transparent",
};

const micBtnStyle = {
  width: "44px",
  height: "44px",
  borderRadius: "50%",
  backgroundColor: "#023377",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
};

const endCallBtnStyle = {
  width: "62px",
  height: "40px",
  borderRadius: "40px",
  backgroundColor: "#ff4343",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
};

const dotsBtnStyle = {
  width: "44px",
  height: "44px",
  borderRadius: "50%",
  backgroundColor: "#023377",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  position: "relative",
};

const badgeDotBarStyle = {
  position: "absolute",
  top: "2px",
  right: "2px",
  width: "10px",
  height: "10px",
  borderRadius: "50%",
  backgroundColor: "red",
};

const backdropStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.4)",
  zIndex: 50,
};

const sheetStyle = {
  position: "fixed",
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: "#2d2d2d",
  borderRadius: "16px 16px 0 0",
  padding: "12px 16px 32px",
  zIndex: 51,
  animation: "slideUp 0.25s ease-out",
};

const handleBarStyle = {
  width: "40px",
  height: "4px",
  backgroundColor: "#5f6368",
  borderRadius: "2px",
  margin: "0 auto 16px",
};

const optionsGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "16px",
  textAlign: "center",
};

const optionBtnStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "6px",
  color: "#e8eaed",
  fontSize: "11px",
  cursor: "pointer",
  background: "none",
  border: "none",
  padding: 0,
};

const optionIconStyle = {
  width: "48px",
  height: "48px",
  borderRadius: "50%",
  backgroundColor: "#3c4043",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "20px",
  color: "#e8eaed",
  position: "relative",
};

const optionLabelStyle = {
  fontSize: "10px",
  color: "#aaa",
};

const badgeDotStyle = {
  position: "absolute",
  top: "2px",
  right: "2px",
  width: "10px",
  height: "10px",
  borderRadius: "50%",
  backgroundColor: "red",
};
